// extracted by mini-css-extract-plugin
export default {"root":"Page_root__z5QWJ","content_s":"Page_content_s__z4cm3","scrollingDisabled":"Page_scrollingDisabled__j3haN"};